<template>
  <div v-if="notif">
    <div
      class="storage-notification alert"
      v-bind:class="{
        storageNormal: this.recordingSizeNotif.has('normal'),
        storageWarning: this.recordingSizeNotif.has('warning'),
        'alert-danger': this.recordingSizeNotif.has('overusage'),
      }"
    >
      <span
        >You have used {{ this.totalRecordingStorageSizeUsed }} out of
        {{ this.maximumStorageSize }} available recording.
        <span id="notice" v-if="this.recordingSizeNotif.has('warning')">
          You are approaching your storage limit -
          <a :href="helpLinks.liveswitch.contact.link" target="_blank"
            >contact sales</a
          >
          for more storage.</span
        >
        <span id="notice" v-if="this.recordingSizeNotif.has('overusage')">
          You will be charged for over usage -
          <a :href="helpLinks.liveswitch.contact.link" target="_blank"
            >contact sales</a
          >
          for more storage.</span
        >
      </span>
    </div>
  </div>
</template>

<script>
import helpLinks from "../../contextualHelpLinks.js";
import { get } from "vuex-pathify";
const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];

export default {
  data: () => ({
    helpLinks: helpLinks,
    usedStorageSize: 0,
    maximumStorageSize: "",
    totalRecordingStorageSizeUsed: "",
    recordingSizeNotif: new Set([]),
    loaded: false
  }),
  computed: {
    maximumSize: get("recording/maximumSize"),
    totalSize: get("recording/totalSize"),
    notif: function () {
      if (this.maximumSize == 0) {
        return false;
      }

      var i = parseInt(Math.floor(Math.log(this.maximumSize) / Math.log(1024)));
      var size = Math.round(this.maximumSize / Math.pow(1024, i));

      if (size >= 1000) {
        size = size / 1000;
        i++;
      }

      this.maximumStorageSize = size + ' ' + sizes[i];

      if (this.totalSize == 0) {
        this.totalRecordingStorageSizeUsed = "0 " + sizes[i];
        this.recordingSizeNotif.add("normal");

        return true;
      }

      i = parseInt(Math.floor(Math.log(this.totalSize) / Math.log(1024)));
      this.totalRecordingStorageSizeUsed = parseFloat((this.totalSize / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i];

      let percentage = (this.totalSize / this.maximumSize) * 100;
      this.recordingSizeNotif.clear();

      if (percentage < 80) {
        this.recordingSizeNotif.add("normal");
      } else if (percentage <= 100) {
        this.recordingSizeNotif.add("warning");
      } else {
        this.recordingSizeNotif.add("overusage");
      }

      return true;
    }
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/fm/colours";
@import "../../assets/scss/md/variables";

.storage-notification {
  display: flex;
  justify-content: center;
  margin-bottom: 3%;
  z-index: 2 !important;
}

#notice {
  display: inline;
}

#notice a {
  color: white !important;
  text-decoration: underline;
}

.storageNormal {
  background-color: $fm-green;
}

.storageWarning {
  background-color: #dcb500;
}

.storage-notification > span {
  color: white;
  font-size: 1rem;
}
</style>
